const TextMobile = ({
  id,
  type,
  name,
  value,
  onChange,
  onKeyDown,
  handleBlur,
}) => {
  return (
    <div className="mobile lo_mobile_wrapper">
      <span className="mobile_label">+91</span>
      <input
        id={id}
        className="mobile_input"
        type={"tel"}
        name={name}
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        onBlur={handleBlur}
        autoComplete="false"
      />
    </div>
  );
};

export default TextMobile;
